import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Initialize state directly from localStorage to avoid flickers
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('club_user');
    return saved ? JSON.parse(saved) : null;
  });

  const [sessions, setSessions] = useState(() => {
    const saved = localStorage.getItem('club_sessions');
    return saved ? JSON.parse(saved) : [];
  });

  // Persist User changes
  useEffect(() => {
    if (user) {
      localStorage.setItem('club_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('club_user');
    }
  }, [user]);

  // Persist Sessions changes
  useEffect(() => {
    localStorage.setItem('club_sessions', JSON.stringify(sessions));
  }, [sessions]);

  const addSession = (session) => setSessions((prev) => [session, ...prev]);

  const finalizeSession = (id, paymentData) => {
    setSessions((prev) =>
      prev.map((s) =>
        s.id === id
          ? { ...s, ...paymentData, status: 'closed', actualEnd: Date.now() }
          : s
      )
    );
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('club_user'); // Explicit clear
  };

  return (
    <AppContext.Provider
      value={{ user, setUser, sessions, addSession, finalizeSession, logout }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);